import { styled } from 'stitches.config'
import { Icon } from 'components/Icon'

export const HowItWorksRoot = styled('section', {
  color: '$accent-black',
  backgroundColor: '$accent-white',
  padding: '$6 0 $2',
  '@bp2': {
    padding: '$10 $4 $10',
  },
})

export const HeaderBox = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '24px',
  gap: '16px',
  padding: '0 $2',

  '@bp2': {
    marginBottom: '52px',
    gap: '$3',
  },
})

export const Header = styled('h2', {
  fontSize: '$h3',
  textAlign: 'center',
  lineHeight: 'normal',
  fontWeight: '$extraLight',
  '@bp2': {
    lineHeight: '$h1',
    fontSize: '$h1',
    maxWidth: '100%',
  },
})

export const HowItWorksBox = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  margin: 'auto',
  marginBottom: 0,
  gap: '0px',
  flexDirection: 'column',
  maxWidth: '500px',

  '@bp2': {
    flexDirection: 'row',
    maxWidth: '1292px',
    gap: '42px',
    marginBottom: '32px',
  },

  '@bp3': {
    gap: '68px',
    marginBottom: '48px',
  },
})

export const ImageColumn = styled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
})

export const TextColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '$3',
  padding: '$4 $2 $5',
  alignItems: 'center',

  '@bp2': {
    padding: 0,
    paddingRight: '$4',
    gap: '$3',
    alignItems: 'flex-start',
  },
  '@bp3': {
    paddingRight: '$8',
    gap: '$4',
  },
})

export const PointsList = styled('ul', {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  gap: '$2',
  display: 'flex',
  flexDirection: 'column',
  '@bp2': {
    gap: '$4',
  },
})

export const PointsListItem = styled('li', {
  listStyle: 'none',
  display: 'flex',
  flexDirection: 'row',
  gap: '$2',
  '@bp2': {
    alignItems: 'center',
  },
})

export const CheckIcon = styled(Icon, {
  width: '11px',
  height: '16px',
  border: '1px solid $primary-500',
  borderRadius: '$round',
  padding: '2px',
  color: '$primary-500',
  fill: '$primary-500',
  marginTop: '4px',
  '@bp2': {
    marginTop: '0',
  },
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  width: '500px',
  aspectRatio: '1.435/1',

  '@bp2': {
    aspectRatio: 'unset',
    width: '507px',
    height: '382px',
  },

  '@bp3': {
    width: '634px',
    height: '477px',
  },
})
